export const NormalInitStrategyConfig = Object.freeze({
  publicRoute: 'cancelado',
  checkSso: 'none',
  pkceMethod: 'S256',
  checkLoginIframe: false,
  flow: 'standard',
});
